import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { string } from 'prop-types';

import { BRANDS } from './shop-garden-brands';

const BrandsPod = ({ title, trackingParam }) => {
  return (
    <div data-component="BrandsPod" className="sui-flex sui-flex-col sui-gap-4">
      <Typography variant="h2" weight="display">{title}</Typography>
      <div className="sui-bg-primary sui-py-4 sui-px-2">
        <ul className="sui-flex sui-flex-wrap sui-justify-center">
          {BRANDS.map(({ src, title: titleBrand, href }) => (
            <li key={titleBrand} className="lg:sui-mx-4 lg:sui-px-1 xs:sui-mx-0 xs:sui-px-0">
              <a href={`${href}${trackingParam}`}>
                <img
                  src={src}
                  alt={`${titleBrand} logo`}
                  height="50"
                  width="120"
                  loading="lazy"
                  className="sui-h-14 sui-w-32 sui-object-scale-down sui-mx-auto"
                />
                <Typography variant="body-base" component="h3" align="center">{titleBrand}</Typography>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

BrandsPod.propTypes = {
  title: string,
  trackingParam: string,
};

BrandsPod.defaultProps = {
  title: '',
  trackingParam: '',
};

BrandsPod.displayName = 'BrandsPod';

export default BrandsPod
